module.exports = __WEBPACK_EXTERNAL_MODULE_18__;


//////////////////
// WEBPACK FOOTER
// external "polyglot"
// module id = 18
// module chunks = 0 1 2 3